$shm_ba_mention_stats_task $shm_mentionstat_task
